import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-pink-50 via-white to-cyan-50 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-pink-400 to-cyan-400 rounded-xl">
                <i className="ri-star-fill text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold text-gray-900">STELLAR LIVE</span>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed">
              輝く才能を世界へ届ける
              <br />
              VTuberプロダクション
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-900 mb-4">タレント</h4>
            <div className="h-px bg-gradient-to-r from-pink-300 to-cyan-300 mb-4"></div>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('talents')}
                  className="text-sm text-gray-600 hover:text-pink-500 transition-colors cursor-pointer"
                >
                  所属タレント一覧
                </button>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-600 hover:text-pink-500 transition-colors">
                  配信スケジュール
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-600 hover:text-pink-500 transition-colors">
                  イベント情報
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-900 mb-4">事務所について</h4>
            <div className="h-px bg-gradient-to-r from-pink-300 to-cyan-300 mb-4"></div>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-sm text-gray-600 hover:text-pink-500 transition-colors cursor-pointer"
                >
                  会社概要
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-gray-600 hover:text-pink-500 transition-colors cursor-pointer"
                >
                  サービス
                </button>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-600 hover:text-pink-500 transition-colors">
                  採用情報
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-900 mb-4">お問い合わせ</h4>
            <div className="h-px bg-gradient-to-r from-pink-300 to-cyan-300 mb-4"></div>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-sm text-gray-600 hover:text-pink-500 transition-colors cursor-pointer"
                >
                  オーディション応募
                </button>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-600 hover:text-pink-500 transition-colors">
                  お仕事のご依頼
                </a>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-gray-600 hover:text-pink-500 transition-colors">
                  プライバシーポリシー
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-6 md:mb-0">
              <p className="text-5xl md:text-7xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-cyan-400">STELLAR</p>
              <div className="h-1 w-24 bg-gradient-to-r from-pink-400 to-cyan-400 mt-2 rounded-full"></div>
              <p className="text-xs text-gray-500 mt-2">輝く才能を世界へ</p>
            </div>

            <div className="text-center md:text-right">
              <p className="text-sm text-gray-600 mb-4">
                © 2025 STELLAR LIVE. All rights reserved. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-pink-500 transition-colors">Powered by Readdy</a>
              </p>
              <div className="flex items-center justify-center md:justify-end space-x-4">
                <a href="#" className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-pink-500 to-cyan-500 text-white rounded-full hover:opacity-80 transition-opacity">
                  <i className="ri-twitter-x-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-pink-500 to-cyan-500 text-white rounded-full hover:opacity-80 transition-opacity">
                  <i className="ri-youtube-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-pink-500 to-cyan-500 text-white rounded-full hover:opacity-80 transition-opacity">
                  <i className="ri-instagram-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-pink-500 to-cyan-500 text-white rounded-full hover:opacity-80 transition-opacity">
                  <i className="ri-discord-fill text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
